<main>
  <slot />
</main>

<style lang="scss">
  main {
    background-color: $color-light-gray;
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    height: fit-content;
  }
</style>
